import React, { useCallback, useEffect } from 'react'
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography'
import SideStyle from '../style/sideStyle';
import Param from '../store/param';
import Control from '../store/control';


const FormMarking = () => {
  const style          = SideStyle();
  const setup          = Param.Get('setup');
  const marking        = Param.Get('marking');
  const setParam       = Param.Get('setParam');
  const debug          = Param.Get('debug');
  const SetCameraFront = Control.Get('SetCameraFront');
  const SetCameraRight = Control.Get('SetCameraRight');
  const SetCameraLeft  = Control.Get('SetCameraLeft');
  const setControl = Control.Get('setControl');

  function setModifyCenter() {
    setControl(s => {s.toModifyCenter = true});
  };

  useEffect(() => {
    //setModifyCenter();
    setParam(s => {s.instructionText = 'Click the each button of Tibia and Fibula and click proper positions'});
  }, [])

  useEffect(() => {
    setControl(s => {s.flgLegClickable = true, s.flgSocketClickable = false});

    //if(marking.target <= 2){
    if(marking.target <= 2){
      SetCameraFront(0);
    }
    else if(marking.target >= 5){
    }
    else {
      if(setup.side == 1){ // Right
        SetCameraRight(0);
      }else if(setup.side == 0){ // Left
        SetCameraLeft(0);
      }
    }
  });

  /**
   * Retrieves the text representation of a target from the marking object.
   * @param {string} target - The target to retrieve the text for.
   * @returns {string|null} - The text representation of the target, or null if it doesn't exist.
   */
  function getText(target){
    const text = marking.vpt[target] ? "(" + marking.vpt[target].x.toFixed(1) + ", " 
      + marking.vpt[target].y.toFixed(1) + ", " 
      + marking.vpt[target].z.toFixed(1) + ")" 
    : null;
    return text;
  }

  /**
   * Handles the click event for marking.
   * @param {string} target - The target of the marking.
   */
  const onClick = useCallback((target) => {
    setParam(s => {s.marking.target = target});
    // console.log("marking.target", target);
  })

  const onClickBackWall = () => {
    setParam(s => {s.marking.modifyBackWall = true});
  }

  /**
   * Returns the CSS classes for the active button based on the target.
   * @param {string} target - The target value to compare with marking.target.
   * @returns {string} - The CSS classes for the active button.
   */
  const getActive = (target) => {
    return (marking.target == target)
      ? `${style.button} ${style.buttonSelected}`
      : style.button;
  }

  return (
    <div className={style.outside}>
      <Grid container direction='column' justifyContent ='flex-start' alignItems='center'>
        <Grid item xs={12} className={style.subcategory}>Tibia</Grid>
      </Grid>
      <Grid container spacing={1} alignItems='center'>
        <Grid item xs={4}>
          <Button name="target" className={getActive(0)} onClick={() => onClick(0)} size="small" >Tubercle</Button>
        </Grid>
        <Grid item xs={4}>
          <Button name="target" className={getActive(1)} onClick={() => onClick(1)} size="small" >Condylar</Button>
        </Grid>
        <Grid item xs={4}>
          <Button name="target" className={getActive(2)} onClick={() => onClick(2)} size="small" >Distal End</Button>
        </Grid>
      </Grid>

      {debug &&
      <div>
        <Grid container spacing={1} alignItems='center'>
          <Grid item xs={4}>
            <Typography>{getText(0)}</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography>{getText(1)}</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography>{getText(2)}</Typography>
          </Grid>
        </Grid>
      </div>}

      <Grid container direction='column' justifyContent ='flex-start' alignItems='center'>
        <Grid item xs={12} className={style.subcategory}>Fibula</Grid>
      </Grid>
      <Grid container spacing={1} alignItems='center'>
        <Grid item xs={4}>
          <Button name="target" className={getActive(3)} onClick={() => onClick(3)} size="small" >Head</Button>
        </Grid>
        <Grid item xs={4}>
          <Button name="target" className={getActive(4)} onClick={() => onClick(4)} size="small" >Distal End</Button>
        </Grid>
      </Grid>

      {debug &&
      <div>
        <Grid container spacing={1} alignItems='center'>
          <Grid item xs={4}>
            <Typography>{getText(3)}</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography>{getText(4)}</Typography>
          </Grid>
        </Grid>
      </div>}

      <Grid container direction='column' justifyContent ='flex-start' alignItems='center'>
        <Grid item xs={12} className={style.subcategory}>User Area</Grid>
      </Grid>
      <Grid container spacing={1} alignItems='center'>
        <Grid item xs={4}>
          <Button name="target" className={getActive(5)} onClick={() => onClick(5)} size="small" >1</Button>
        </Grid>
        <Grid item xs={4}>
          <Button name="target" className={getActive(6)} onClick={() => onClick(6)} size="small" >2</Button>
        </Grid>
        <Grid item xs={4}>
          <Button name="target" className={getActive(7)} onClick={() => onClick(7)} size="small" >3</Button>
        </Grid>
      </Grid>

      {debug &&
      <div>
        <Grid container spacing={1} alignItems='center'>
          <Grid item xs={4}>
            <Typography>{getText(5)}</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography>{getText(6)}</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography>{getText(7)}</Typography>
          </Grid>
        </Grid>
      </div>}


      <Grid container spacing={1} alignItems='center'>
        <Grid item xs={4}>
          <Button name="target" className={getActive(8)} onClick={() => onClick(8)} size="small" >4</Button>
        </Grid>
        <Grid item xs={4}>
          <Button name="target" className={getActive(9)} onClick={() => onClick(9)} size="small" >5</Button>
        </Grid>
      </Grid>

      {debug &&
      <div>
        <Grid container spacing={1} alignItems='center'>
          <Grid item xs={4}>
            <Typography>{getText(8)}</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography>{getText(9)}</Typography>
          </Grid>
        </Grid>
      </div>}



      {/* <Grid container direction='column' justifyContent ='flex-start' alignItems='center'>
        <Grid item xs={12} className={style.subcategory}>Back side wall</Grid>
      </Grid>
      <Grid container spacing={1} alignItems='center'>
        <Button name='modifyBackWall' className={style.button} onClick={() => onClickBackWall()} size="small" >Apply modify</Button>
      </Grid> */}

    </div>
  );
}
export default FormMarking;
